import React, { useEffect, useState, useRef } from "react";

import { auth, firebase } from "../../Firebase/config";

import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  FieldValue,
  getCountFromServer,
} from "@firebase/firestore";

import {
  Link,
  Route,
  Routes,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import "../Messages.css";

export default function Phonelessstudents({
  currentclass,
  activename,
  setSelectedclass,
  activeid2,
  activename2,
  selectedclass,
  currentstudent,
  setCurrentstudent,
  studentidd,
  parentlanguagecode,
  id2,
  temparray,
  databaseactivename,
  activeid,
  id,
  role, 
  accesstokenn,
  refreshtokenn,
  expirydatee,
  email
}) {

  const [lasttwomonths, setlasttwomonths] = useState([]);

  const [searchingstate, setSearchingstate] = useState(false);
  const [aallpasses, setAallpasses] = useState();

  const [filteredstates, setFilteredstates] = useState([]);

  const [activpasses, setActivpasses] = useState([]);
  const [update, setUpdate] = useState();

  const [changehasbeenmade, setChangehasbeenmade] = useState();
  const [endtime, setEndtime] = useState();
  const [begintime, setBegintime] = useState();

  const [revise, setRevise] = useState();

  const [passesbetween, setPassesbetween] = useState();

  const [currentclass2, setCurrentclass2] = useState();
  const [activeid22, setActiveid2] = useState();

  const [website, setWebsite] = useState();
  const [whatparentssee, setWhatpareentseee] = useState();
  const [thispage, setThispage] = useState();

  const navigate = useNavigate();

  

  const selectHandler = (value, i) => {

    if (value && activeid2 != value.id) {
  
      setSelectedclass(value);
    } else {
      setSelectedclass("");
    }

  };

  useEffect(() => {
    console.log("useEffect called with activeid2:", activeid2);
     console.log("useEffect called with temparray:", temparray);
setThispage(window.location.href)

  }, []);


  async function getstudentsfromgc() {
    console.log("getstudentsfromgc called with activeid2:", activeid2, activeid);
    if (typeof activeid2 != "undefined") {

      updateDoc(doc(firebase, "classesbeingtaught", activeid), {
        googleclassroomid: activeid2,
        googleclassroomname: activename2,
      }).catch((error) => {
        console.log(error); alert(error);
      })


        const API_BASE_URL = "https://api-hkshnm7duq-uc.a.run.app";
        const currentUrl = window.location.href;
         // Get the current URL

        const isProduction = process.env.NODE_ENV === "production";
        const baseUrl = isProduction ? "https://fastclasspass.web.app" : "http://localhost:3000";
        const redirectUrl = `${baseUrl}/role/${role}/mainmenu/id/${id}/gcstudents`;
        
        try {
          const response = await fetch(`${API_BASE_URL}/api/login?state=${encodeURIComponent(JSON.stringify({
            id: id,
            currentUrl: currentUrl,
            task: "fetchStudents",
            redirectUrl: redirectUrl,
            courseId: activeid2,
            databasecourseId: activeid,
            email: email ? email : "",
          }))}`, { method: "GET" });

          // If the backend already had valid tokens it executes directly and
          // redirects back to our app URL — detect that and navigate there.
          const finalUrl = response.url || "";
          if (!finalUrl.startsWith(API_BASE_URL)) {
            window.location.href = `${redirectUrl}?id=${id}&dataStoredInDatabase=true`;
            return;
          }

          const contentType = response.headers.get("content-type") || "";
          if (!contentType.includes("application/json")) {
            window.location.href = `${redirectUrl}?id=${id}&dataStoredInDatabase=true`;
            return;
          }

          const data = await response.json();

          if (data.authUrl) {
            window.location.href = data.authUrl;
          } else {
            console.error("Auth URL not received from the server.");
            alert("Failed to retrieve the authentication URL.");
          }
        } catch (error) {
          console.error(
            "Error during login:",
            error.response?.data || error.message
          );
          alert("Failed to initiate login. Please check the console for details.");
        }
    }
  }

  return (
    <div className="App">
      {typeof temparray != "undefined" ? (
        <div className="App-header">
         {typeof activeid2 != "undefined" ? <div className="centerme295">Selected<br />Google Classroom Class </div>: <div className="centerme295">Select<br />Google Classroom Class</div> }
         <br></br>
          {temparray.map((item, index) => (
            <React.Fragment key={item.id || index}>
           
              {typeof activeid2 == "undefined" ? (
                <div onClick={() => selectHandler(item, index)} className= {activeid2 == item.id
              ? "passtart" : "passstart"}>
                  
                      {item.name}
                      {item.section != null ? <><br></br>{item.section}</> : null}
                
                  
                    <div></div>
                 
                </div>
              ) : typeof activeid2 != "undefined" &&
                activeid2 != item.id ? null : (
               <>
                  <div className= "passstart" onClick={() => selectHandler(item, index)}
                  >
                      {item.name}
                      {item.section != null ? <><br></br>{item.section}</> : null}
                    
                    <div></div>
                  </div>
                  <br></br>

                  {typeof activeid2 != "undefined" ? <div className="passstart222">
                    <div
                      className="innertext"
                      onClick={() => getstudentsfromgc()}
                      >
                      Sync/Copy {databaseactivename} Roster
                      <br />
                      with this GC Roster
                    </div>
                    </div> : null}
                    </>
           
              )}
            </React.Fragment>
          ))}
        </div>
      ) : null}
      <br></br>
    </div>
  );
}

/* <View>
<div
  style={
    item.id === idselected ? styles.selected : styles.unselected
  }
  onClick={() => selectHandler(item)}>
  <div style={styles.end}>{item.firstname} {item.lastname}{'\n'}{new Date(item.leftclass).toString().substr(4, 11)} @ {item.timeleftclass}{'\n'}{item.comingfrom} -{item.destination} - {item.timeallowedonpass} min.</div>
</div>


</View> */